export default __webpack_public_path__ + "static/media/Border Kingdom Helm.0bd25694.jpg";